import type { LocationQuery } from 'vue-router';

import { CANDIDATE_TABS, type CandidateTab } from '@/composables/jobs/candidateTabs';

export const DEEP_LINK_QUERY_KEYS = [
  'conversationId',
  'jobApplicantId',
  'jobId',
  'projects',
] as const;

// Left in a click's query, a pending deep link would win over the click in the route watcher.
// A legacy `tab=my_jobs|all_jobs` is jobs scope, not a deep link, so only candidate tabs go.
export function withoutDeepLinkQuery(query: LocationQuery): LocationQuery {
  const rest: LocationQuery = { ...query };
  for (const key of DEEP_LINK_QUERY_KEYS) {
    delete rest[key];
  }
  if (CANDIDATE_TABS.includes(rest.tab as CandidateTab)) {
    delete rest.tab;
  }
  return rest;
}

export function hasDeepLinkQuery(query: LocationQuery): boolean {
  return DEEP_LINK_QUERY_KEYS.some((key) => query[key] !== undefined);
}
